package nl.appstuff.padelchecker.site.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant

@Composable
fun BrandLogo(
    lightVariant: Boolean,
    modifier: Modifier = Modifier,
    path: String = "/",
) {
    Link(
        path = path,
        variant = UncoloredLinkVariant,
        modifier = Modifier.textDecorationLine(TextDecorationLine.None),
    ) {
        Image(
            src = if (lightVariant) "/images/logo_light.svg" else "/images/logo_dark.svg",
            alt = "Padelchecker",
            modifier = modifier.styleModifier {
                property("display", "block")
                property("object-fit", "contain")
            },
        )
    }
}
